import styled, { css } from 'styled-components'

const mainColor = '#202020';
const subColor = '#565656';
const disabledColor = '#E3E3E3';
const faBackground = '#EEF5FF';

// const subColor = '#A8A8A8';
// const faBackground = '#FAFAFA';

const shrinkLabelStyles = css`
    top: -14px;
    font-size: 11px;
    color: ${subColor};
`

export const GroupContainer = styled.div`
    position: relative;
    margin: 16px 0;

    input[type='password'] {
        letter-spacing: 0.3em;
    }
`

export const FormInputContainer = styled.input`
    background: none;
    background-color: ${({ greybg }) => (greybg ? `${faBackground}` : '')};
    color: ${({ greybg }) => (greybg ? `#202020` : `${mainColor}`)};
    font-size: 16px;
    padding: 8px 8px 8px 0;
    display: block;
    width: 100%;
    border: none;
    border-radius: 0;
    border-bottom: ${({ greybg }) => (greybg ? `1px solid ${disabledColor}` : `1px solid ${subColor}`)};

    /* &:hover {
        border-bottom: ${({ greybg }) => (greybg ? '' : `2px solid ${mainColor}`)}
    } */

    &:focus {
        border-bottom:2px solid ${mainColor};
        outline: none;
    }

    &:focus ~ label {
        ${shrinkLabelStyles}
    }
`

export const FormInputLabel = styled.label`
    color: ${subColor};
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 0;
    top: 8px;
    transition: 300ms ease all;

    &.shrink {
        ${shrinkLabelStyles}
    }
`

export const ErrorMessage = styled.p`
    color: red;
    font-size: 12px;
    padding-bottom: 16px;
`